import { Box, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'

const PULSE_SIZE_PX = 22
const PULSE_DURATION_MS = 1600

/** Pulsing red circle marking the crash selected from the Notification Center. */
export function NotificationCrashPulse() {
  const theme = useTheme()
  const color = theme.palette.error.main

  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        width: PULSE_SIZE_PX,
        height: PULSE_SIZE_PX,
        borderRadius: '50%',
        bgcolor: color,
        border: `3px solid ${theme.palette.common.white}`,
        boxShadow: theme.shadows[3],
        '@keyframes notificationCrashPulse': {
          '0%': { transform: 'scale(1)', opacity: 0.7 },
          '100%': { transform: 'scale(3.2)', opacity: 0 },
        },
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          inset: -3,
          borderRadius: '50%',
          bgcolor: alpha(color, 0.45),
          animation: `notificationCrashPulse ${PULSE_DURATION_MS}ms ease-out infinite`,
        },
        '&::after': { animationDelay: `${PULSE_DURATION_MS / 2}ms` },
      }}
    />
  )
}
